module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dark"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "side-nav side-nav-left center"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('router-link', {
    attrs: {
      "to": "/italics-dashes"
    }
  }, [_vm._v("▲"), _c('br'), _vm._v("Italics, -, –, —, and ˜")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "side-nav side-nav-right center"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('router-link', {
    attrs: {
      "to": "/expressive-type"
    }
  }, [_vm._v("Expressive Type"), _c('br'), _vm._v("▼")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content--first yellow text--darkgreen clear"
  }, [_c('div', {
    staticClass: "column--single spacer--small"
  }, [_c('h3', {
    staticClass: "spacer--small caps center"
  }, [_vm._v("Make a Face")]), _vm._v(" "), _c('faces')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content darkyellow text--darkgreen"
  }, [_c('div', {
    staticClass: "spacer--medium"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer--medium center"
  }, [_c('router-link', {
    staticClass: "button caps",
    attrs: {
      "to": "/expressive-type"
    }
  }, [_vm._v("Next Chapter")])], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer--small"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrap clear"
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('div', {
    staticClass: "header-section-title-conno caps rotate"
  }, [_vm._v("\n          Connotatives\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('span', {
    staticClass: "header-section-number"
  }, [_vm._v("2–2")]), _vm._v(" "), _c('h1', [_vm._v("Emoticons & Text")]), _vm._v(" "), _c('p', {
    staticClass: "header-section-desc"
  }, [_vm._v("TLDR; :D Haha! "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅎ_ㅎ")]), _vm._v(" OMG... "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("^ㅁ^")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column--single"
  }, [_c('div', {
    staticClass: "column--single"
  }, [_c('h3', {
    staticClass: "center caps"
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('div', {
    staticClass: "abbreviations-wrapper spacer--medium"
  }, [_c('div', {
    staticClass: "column--one-third spacer--small"
  }, [_c('div', {
    staticClass: "arrow-container-white white-tri-right right-top center kr-sans"
  }, [_c('div', {
    staticClass: "abbrev-text-box"
  }, [_vm._v("\n                            ㅋㅋㅋ\n                        ")])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "arrow-container-yellow yellow-tri-right left-top center"
  }, [_c('div', {
    staticClass: "abbrev-text-box"
  }, [_vm._v("\n                            haha\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column--two-thirds spacer--small"
  }, [_c('div', {
    staticClass: "column--single"
  }, [_c('h3', [_c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("ㅋㅋㅋ")]), _vm._v(" / haha")]), _vm._v(" "), _c('p', {
    staticClass: "serif"
  }, [_vm._v("To indicate laughter, literally kkkkkk.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear rule"
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer--small"
  }), _vm._v(" "), _c('div', {
    staticClass: "abbreviations-wrapper spacer--medium"
  }, [_c('div', {
    staticClass: "column--two-thirds"
  }, [_c('div', {
    staticClass: "column--single spacer--small"
  }, [_c('h3', [_c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("ㅎㅎㅎ")]), _vm._v(" / heh")]), _vm._v(" "), _c('p', {
    staticClass: "serif"
  }, [_vm._v("To indicate breathes of laughter, literally hhh.")])])]), _vm._v(" "), _c('div', {
    staticClass: "column--one-third spacer--small"
  }, [_c('div', {
    staticClass: "arrow-container-white white-tri-right right-top center kr-sans"
  }, [_c('div', {
    staticClass: "abbrev-text-box"
  }, [_vm._v("\n                            ㅎㅎㅎ\n                        ")])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "arrow-container-yellow yellow-tri-right left-top center"
  }, [_c('div', {
    staticClass: "abbrev-text-box"
  }, [_vm._v("\n                            heh\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear rule"
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer--small"
  }), _vm._v(" "), _c('div', {
    staticClass: "abbreviations-wrapper  spacer--medium"
  }, [_c('div', {
    staticClass: "column--one-third spacer--small"
  }, [_c('div', {
    staticClass: "arrow-container-white white-tri-right right-top center kr-sans"
  }, [_c('div', {
    staticClass: "abbrev-text-box"
  }, [_vm._v("\n                            ㅇㅋ\n                        ")])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "arrow-container-yellow yellow-tri-right left-top center"
  }, [_c('div', {
    staticClass: "abbrev-text-box"
  }, [_vm._v("\n                            OK\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column--two-thirds"
  }, [_c('div', {
    staticClass: "column--single spacer--small"
  }, [_c('h3', [_c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("ㅇㅋ")]), _vm._v(" / OK")]), _vm._v(" "), _c('p', {
    staticClass: "serif"
  }, [_vm._v("The letter "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("‘ㅇ’")]), _vm._v(" looks like the letter ‘O’ and "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("‘ㅋ’")]), _vm._v(" is pronounced like the ‘k’ sound.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear rule"
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer--small"
  }, [_c('div', {
    staticClass: "abbreviations-wrapper spacer--medium"
  }, [_c('div', {
    staticClass: "column--two-thirds"
  }, [_c('div', {
    staticClass: "column--single spacer--small"
  }, [_c('h3', [_c('span', {
    staticClass: "kr-sans-bold"
  }, [_vm._v("ㅅㄱ")]), _vm._v(" / GG")]), _vm._v(" "), _c('p', {
    staticClass: "serif"
  }, [_vm._v("A casual of saying good game or good job. "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("ㅅㄱ")]), _vm._v(" is short hand for "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("수고하세요.")]), _vm._v(" The "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("‘ㅅ’")]), _vm._v(" represents the ‘s’ sound and "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("‘ㄱ’")]), _vm._v(" represents the ‘g’ sound.")])])]), _vm._v(" "), _c('div', {
    staticClass: "column--one-third spacer--small"
  }, [_c('div', {
    staticClass: "arrow-container-white white-tri-right right-top center kr-sans"
  }, [_c('div', {
    staticClass: "abbrev-text-box"
  }, [_vm._v("\n                            ㅅㄱ\n                        ")])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "arrow-container-yellow yellow-tri-right left-top center"
  }, [_c('div', {
    staticClass: "abbrev-text-box"
  }, [_vm._v("\n                            GG\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small clear"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3df80793","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/EmoticonsText.vue
// module id = 140
// module chunks = 0